import React, { useEffect } from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import "../css/for-landloards.css"
import waveHeader from "../assets/images/for-lanlord/wave_header.png"
import rightArrow from "../assets/images/for-lanlord/right-arrow.png"
import rain from "../assets/images/for-lanlord/rain.png"
import insurent from "../assets/images/for-lanlord/insurent.png"
import guarantors from "../assets/images/for-lanlord/guarantors.png"
import "aos/dist/aos.css"
import AOS from "aos"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import element2 from "../assets/images/faq/element_2.svg"
import element3 from "../assets/images/faq/element_3.svg"
import wavCircle2 from "../assets/images/faq/wave_circle_faq_2.svg"
import wavCircle from "../assets/images/faq/wave_circle_faq_1.svg"
import { FaTimes } from "react-icons/fa"
import elementSol from "../assets/images/for-student/element_solutions.png"
import elementSolMob from "../assets/images/for-student/element_solutions_mob.png"
import elementSo2 from "../assets/images/for-student/element_solutions_1.png"
import waveUndorm from "../assets/images/for-student/wave_undorm.png"
import FaqComp from "../components/Faq2"
import winnerLineBg1 from "../assets/images/listing-place/winner-bg-img-2.png"

const LandLoards = ({ data }) => {
  const {
    strapiForLandLords: {
      hero_heading,
      hero_subheading,
      hero_img: { localFile },
      reasons,
      reason_description,
      calltoaction1_heading,
      calltoaction1_subheading,
      calltoaction1_points,
      calltoaction2_heading,
      calltoaction2_img,
      calltoaction2_description1,
      calltoaction2_description2,
    },
  } = data

  const mainImg = getImage(localFile)

  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 100,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 1200,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    })
  }, [])
  return (
    <Layout>
      <Seo Sitetitle="For Guarantors" />
      <>
        <section className="hero-section mt-lg-3">
          <div data-aos="fade-left" className="d-lg-none">
            <GatsbyImage
              data-aos="fade-right"
              image={mainImg}
              className="img-fluid hero-png"
              alt="section-img-1"
            />
            <div className="text-right">
              <img
                src={waveHeader}
                className="img-fluid header_wave"
                alt="wave_header"
              />
            </div>
          </div>
          <div data-aos="fade-left" className="padding-left position-relative">
            <div className="container-fluid">
              <div className="row reverse-columan">
                <div className="col-lg-7 navigatin-details-outer">
                  <p className="navigatin-details">
                    Home{" "}
                    <img
                      src={rightArrow}
                      className="img-fluid mx-2"
                      alt="right-arrow"
                    />{" "}
                    <b className="font-weight-bold"> For Guarantors</b>
                  </p>
                  <h1 className="main-page-heading guarantor-h">
                    {hero_heading}
                  </h1>
                  <div className="hero-para d-flex pl-lg-1">
                    <span className="left-wraper-main" />
                    <span className="hero-para-txt guarantor-p">
                      {hero_subheading}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <GatsbyImage
            data-aos={"fade-right"}
            image={mainImg}
            className="img-fluid hero-png hide-form-mob"
            alt="section-img-1"
          />
          <img
            data-aos="fade-right"
            src={waveHeader}
            className="img-fluid header_wave hide-form-mob"
            alt="wave_header"
          />
        </section>
        <section className="position-relative undrom-section main-section padding-bottom">
          <img
            data-aos="fade-left"
            src={elementSol}
            className="img-fluid undrom_right d-lg-inline-block d-none"
            alt="element_solutions"
          />
          <img
            data-aos="fade-left"
            src={elementSolMob}
            className="img-fluid undrom_right img-bottom d-lg-none"
            alt="element_solutions"
          />
          <div className="container my-0 my-lg-5 me-5 d-lg-block d-none">
            <h3 className="mt-3" data-aos="fade-left">
              <div className="hero-para d-flex pl-lg-1">
                <span className="left-wraper" />
                <span className="hero-para-txt">
                  This is likely due to:
                  <ul
                    className="list-unstyled buying-ways section-3-inner space-form-left margin-left my-4"
                    data-aos="fade-up"
                  >
                    {reasons.map(reason => {
                      return (
                        <li className="d-flex large-txt" key={reason.id}>
                          <FaTimes className="times time" />
                          <span>{reason.main_points}</span>
                        </li>
                      )
                    })}
                  </ul>
                  <div className="left-wraper-l remove-from-mob" />
                  <br className="d-block" />
                </span>
              </div>
            </h3>
          </div>
          <div className="d-lg-none d-block mob-lik">
            <p className="mob-g-p">This is likely due to:</p>
            <ul className="mob-g-ul" data-aos="fade-up">
              {reasons.map(reason => {
                return (
                  <li className="d-flex large-txt" key={reason.id}>
                    <FaTimes className="times time" />
                    <span>{reason.main_points}</span>
                  </li>
                )
              })}
            </ul>
            <div className="left-wraper-l-mob remove-from-mob" />
            <br className="d-block" />
          </div>
        </section>
        <div data-aos="fade-left">
          <p className="reason-desc">{reason_description}</p>
        </div>
        <div className="winner-img-outer">
          <div className="img-outer-padding">
            <img
              src={winnerLineBg1}
              className="img-fluid circle-blue1"
              alt="lines background"
            />
            <div
              className="text-lg-center text-start cta-div"
              data-aos="fade-left"
            >
              <h2 className="rb2 cta1">{calltoaction1_heading}</h2>
            </div>
          </div>
          <img
            src={winnerLineBg1}
            className="img-fluid circle-blue2"
            alt="lines background"
          />
        </div>
        <section className="position-relative main-section solutions my-3 main-cta">
          <img
            data-aos="fade-up"
            src={elementSo2}
            className="img-fluid solutions_left"
            alt="element_solutions_1"
          />
          <h5 className="cta-h">{calltoaction1_subheading}</h5>
          <ul className="my-ul">
            {calltoaction1_points.map((item, index) => {
              return (
                <li key={item.id}>
                  <span className="numbs">{index + 1}</span>
                  {item.main_points}
                </li>
              )
            })}
          </ul>
        </section>
        <section className="contact-ban">
          <h3 data-aos="fade-left" className="rb2">
            To move forward, feel free to get in contact with us:{" "}
          </h3>
          <button data-aos="fade-left" className="btn meet-btn mt-3">
            Contact Undorm About Guarantees{" "}
          </button>
        </section>
        <section className="position-relative undrom-section main-section padding-bottom">
          <div className="position-relative">
            <div data-aos="fade-down" className="stroke-heading hide-left">
              commercial
            </div>
            <div data-aos="fade-down" className="stroke-heading sh2">
              guarantors
            </div>
            <div data-aos="fade-down" className="grant_img_outer">
              <img
                src={calltoaction2_img.localFile.publicURL}
                className="img-fluid undrom_img"
                alt="undorm_image"
              />
            </div>
            <div className="time-to-undrom">
              <div className="container-fluid">
                <div className="row">
                  <div
                    data-aos="fade-right"
                    className="offset-lg-7 col-lg-5 offset-6 col-6 col-adjst-pdng cta2-h2"
                  >
                    <h2 className="main-heading rb2">
                      {calltoaction2_heading}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <img
              data-aos="fade-up"
              src={waveUndorm}
              className="img-fluid wave_guarantors"
              alt="wave_undorm"
            />
          </div>
        </section>
        <h3 className="grant-cta2-hh d-lg-none d-block">
          {calltoaction2_heading}
        </h3>
        <section className="position-relative undrom-section main-section padding-bottom mt-5">
          <img
            data-aos="fade-left"
            src={elementSol}
            className="img-fluid undrom_right d-lg-inline-block d-none"
            alt="element_solutions"
          />
          <img
            data-aos="fade-left"
            src={elementSolMob}
            className="img-fluid undrom_right img-bottom d-lg-none"
            alt="element_solutions"
          />
          <div
            className="cta-2-desc my-5 d-lg-block d-none"
            data-aos="fade-left"
          >
            <div className="left-wraper-l remove-from-mob" />
            <br className="d-block" />
            <p className="cta-2-desc{">{calltoaction2_description1}</p>
            <p className="cta-2-desc{">{calltoaction2_description2}</p>
          </div>
          <div className="d-lg-none d-block cta2-desc-div">
            <div className="left-wraper-l-mob remove-from-mob" />
            <br className="d-block" />
            <p className="cta-2-desc">{calltoaction2_description1}</p>
            <p className="cta-2-desc">{calltoaction2_description2}</p>
          </div>
        </section>

        <div className="container mb-5" data-aos="fade-up">
          <div className="comp d-flex justify-content-center align-items-center flex-column flex-lg-row">
            <img src={rain} alt="rhino" className="img-fluid b-img" />
            <img
              src={guarantors}
              alt="guarantors"
              className="img-fluid b-img"
            />
            <img src={insurent} alt="insurent" className="img-fluid b3-img" />
          </div>
        </div>
        <section className="contact-ban">
          <h3 data-aos="fade-left" className="rb2">
            Inquire about Commercial Guarantees
          </h3>
          <button data-aos="fade-left" className="btn meet-btn mt-3">
            Inquire Now!
          </button>
        </section>

        <h3 className="my-3 faq-h-mob d-lg-none d-block">
          {" "}
          Frequently Asked Questions
        </h3>

        <section className="tab-outer tab-1 position-relative g-faq">
          <h1 className="text-center rb2 text-white">
            Frequently Asked Questions
          </h1>
          <div className="container sit-z-index">
            <FaqComp />
          </div>
          <img
            src={element2}
            className="img-fluid tabs-img tab-1-img active-tab-img element_2"
            alt="element_2"
          />
          <img
            src={element3}
            className="img-fluid tabs-img tab-1-img active-tab-img element_3"
            alt="element_3"
          />
          <img
            src={wavCircle2}
            className="img-fluid tabs-img tab-2-img circle_1"
            alt="wave_circle_faq_2"
          />
          <img
            src={wavCircle}
            className="img-fluid tabs-img tab-2-img circle_2"
            alt="wave_circle_faq_1"
          />
        </section>
      </>
    </Layout>
  )
}

export const query = graphql`
  {
    strapiForLandLords {
      hero_heading
      hero_subheading
      hero_img {
        localFile {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
      reasons {
        id
        main_points
      }
      reason_description
      calltoaction1_heading
      calltoaction1_subheading
      calltoaction1_points {
        id
        main_points
      }
      calltoaction2_heading
      calltoaction2_img {
        localFile {
          publicURL
        }
      }
      calltoaction2_description1
      calltoaction2_description2
    }
  }
`

export default LandLoards
